import clientBackend from "configurations/axios";
import {
  MODULES_FETCH_START,
  MODULES_FETCH_SUCCESS,
  MODULES_FETCH_ERROR,
  MODULE_SELECT,
} from "../types/modulesTypes";

export const fetchModules = (rucEmpresa) => async (dispatch) => {
  try {
    dispatch({ type: MODULES_FETCH_START });
    const resp = await clientBackend.get(`/admin/modulos/${rucEmpresa}`);
    if (resp.status !== 200) throw new Error("Error al cargar módulos");
    const data = await resp.data;

    dispatch({ type: MODULES_FETCH_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: MODULES_FETCH_ERROR,
      payload: err.message || "Error desconocido",
    });
  }
};

export const selectModule = (module) => ({
  type: MODULE_SELECT,
  payload: module,
});
